export default __webpack_public_path__ + "static/media/email.07ee226c.svg";